import {
  getEmploymentFieldVisibility,
  getVacationFieldVisibility,
  type EmploymentFieldVisibility,
  type VacationFieldVisibility,
} from "../shared/staffEmploymentFieldVisibility.logic";
import type { AddStaffFormMode } from "./addStaffPanel.contract";

export interface AddStaffFieldVisibility
  extends EmploymentFieldVisibility, VacationFieldVisibility {
  readonly showPaymentMethod: boolean;
  readonly showPersonalDetails: boolean;
  readonly showTeam: boolean;
}

/**
 * Which fields the add staff form shows: the fields the employment type and
 * salary model have, minus the worker's own details when only an employment is
 * added. Rendering, validation and sections all read this, so a hidden field is
 * never required.
 */
export const getAddStaffFieldVisibility = ({
  employmentType,
  mode,
  salaryType,
}: {
  readonly employmentType: string | undefined;
  readonly mode: AddStaffFormMode;
  readonly salaryType: string | undefined;
}): AddStaffFieldVisibility => {
  const isNewWorker = mode === "newWorker";
  const employmentVisibility = getEmploymentFieldVisibility(employmentType);
  const vacationVisibility = getVacationFieldVisibility(salaryType);

  return {
    ...employmentVisibility,
    ...vacationVisibility,
    showPaymentMethod: isNewWorker,
    showPersonalDetails: isNewWorker,
    showTaxTable: isNewWorker && employmentVisibility.showTaxTable,
    showTeam: isNewWorker,
  };
};
